import { TabList } from '../../Tab'

import * as styles from './ReportTableModalTabBar.module.css'

function ReportTableModalTabBar({ activeTab, tabs, onSetActiveTab }) {
  function getTabs() {
    return tabs
  }

  return (
    <TabList
      activeTab={activeTab}
      className={styles.ReportTableModalTabBar}
      getTabs={getTabs}
      onSetActiveTab={onSetActiveTab}
    />
  )
}

export default ReportTableModalTabBar
